module.exports = __webpack_public_path__ + "static/media/0022_IMG_LES_MURS_PAPIER_BRIQUE_BLANCHE.b2abc41e.png";